import React, { useState } from 'react'
import { Media } from "reactstrap";
import InfoPopup from './InfoPopup';
import moment from 'moment';

const MldReturns = (props) => {

  const [activeComponent, setActiveComponent] = useState("table");
  const [showPopUp, setShowPopUp] = useState(false);
  const formattedMaturityDate = props?.mldAssetDetails?.maturityDate
  ? moment(props.mldAssetDetails.maturityDate).format("Do MMM YY")
  : "NA";
  
  const popUpInfo = `Cap signifies the maximum returns in the MLD product that will be received on Maturity. Floor signifies the minimum returns in the MLD product that will be received on Maturity. The returns are calculated on the Face Value of ₹1,00,000.<b>Maturity Date:${formattedMaturityDate}</b>`;

  const handleToggle = (val) => {
    setActiveComponent(val);
  };

  const handleInfoClick = () => {
    setShowPopUp(!showPopUp)
  }
  const getActiveImage = (type) => {
    switch(type) {
      case "table":
        return (
          props.mldAssetDetails.bondId === "mld3" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "howMuchReturnTable.webp"
                : process.env.REACT_APP_IMAGES_PATH + "howMuchReturnTableMob.webp"}
              alt="mld-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : props.mldAssetDetails.bondId === "mld4" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "nifty-returns-table-web.webp"
                : process.env.REACT_APP_IMAGES_PATH + "nifty-returns-table.webp"}
              alt="mld-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : props.mldAssetDetails.bondId === "mld5" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "nifty-returns-table-mld5.webp"
                : process.env.REACT_APP_IMAGES_PATH + "nifty-returns-table-web-mld5.webp"}
              alt="mld-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : props.mldAssetDetails.bondId === "gmldm0" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "Magnifier+MLD+Returns+Web.webp"
                : process.env.REACT_APP_IMAGES_PATH + "Mobile_Magnifier+MLD+Returnsmobile.webp"}
              alt="gmldm0-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : props.mldAssetDetails.bondId === "gmld1" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "Gold+Twinwin+MLD+Returns+.jpg"
                : process.env.REACT_APP_IMAGES_PATH + "Mobile_Magnifier+MLD+Returns+.jpg"}
              alt="gmld1-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "howMuchReturnTable_old.webp"
                : process.env.REACT_APP_IMAGES_PATH + "howMuchReturnTableMob_old.webp"}
              alt="mld-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          )
        );
  
      case "graph":
        return (
          props.mldAssetDetails.bondId === "mld4" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "mld-payout-graph.webp"
                : process.env.REACT_APP_IMAGES_PATH + "mld-payout-graph.webp"}
              alt="mld-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : props.mldAssetDetails.bondId === "gmldm0" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "Magnifier+MLD+chart.webp"
                : process.env.REACT_APP_IMAGES_PATH + "Magnifier+MLD+chart+Mobile.webp"}
              alt="gmldm0-return-graph"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : props.mldAssetDetails.bondId === "gmld1" ? (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "Desktop_TwinwinMLD+chart.jpg"
                : process.env.REACT_APP_IMAGES_PATH + "Mobile_TwinwinMLD+chart.jpg"}
              alt="gmldm0-return-graph"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          ) : (
            <Media
              src={!props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "howMuchReturnGraph.webp"
                : process.env.REACT_APP_IMAGES_PATH + "howMuchReturnGraphMob.webp"}
              alt="mld-return"
              className="cards-img"
              style={{ maxWidth: "100%" }}
            />
          )
        );
  
      default:
        return null;
    }
  };
  
  

  return (
    <div className="mld-third-fold">
      <p className="mld-fold-three-title text-center">
        {props.mldInvest.thirdFold.title}
      </p>
      {props.mldAssetDetails.bondId === "mld3" ? (
        ""
      ) : (
        <p className="subtext text-center">
          MLD Returns will be{" "}
          {props.mldAssetDetails &&
            (props?.mldAssetDetails?.ISIN === "INE321N07418" ? "up to " : "") +
              props.mldAssetDetails.multiplier.toFixed(1)}
          x{" "}
          {props.mldAssetDetails.bondId === "gmldm0" || props.mldAssetDetails.bondId === "gmld1"
            ? "Gold Futures MCX"
            : "Nifty 50 Index Returns"}
          , with&nbsp;Cap of{" "}
          {props.mldAssetDetails && props.mldAssetDetails.maxReturns}% and a
          Floor of&nbsp;
          {props.mldAssetDetails && props.mldAssetDetails.minReturns}%, and 100%
          Principal Protection at Maturity
          <span
            onClick={handleInfoClick}
            className="mdi mdi-information-outline ml-2"
            style={{
              cursor: "pointer",
              fontSize: "15px",
            }}
          />
        </p>
      )}
      {props.mldAssetDetails.bondId === "mld3" ||
      props.mldAssetDetails.bondId === "mld4"
      ? null
      : props.mldAssetDetails.bondId === "mld5" ? (
        <p className="subtext-2 text-center text-muted">
          For computing Nifty 50 Index Returns, the <b>Initial Observation Dates</b> 
          would be the average Nifty 50 Index levels of <b>20th October 2025</b> and <b>25th November 2025</b>, 
          and the <b>Final Observation Dates</b> would be the average Nifty 50 Index levels of 
          <b> 28th September 2027</b> and <b>26th October 2027</b>
        </p>
      ) : props.mldAssetDetails.bondId === "gmldm0" || props.mldAssetDetails.bondId === "gmld1" ? (
        <p className="subtext-2 text-center text-muted">
          For computing Gold Futures MCX Returns, the Initial Fixing Date would
          be the average of Gold Futures on MCX levels on 07/08/2025,
          28/08/2025, 25/09/2025, 30/10/2025, 27/11/2025 and 24/12/2025 and the
          Final Fixing Date would be the average of Gold Futures on MCX levels
          on 25/05/2028, 29/06/2028, 27/07/2028, 31/08/2028, 28/09/2028 and
          26/10/2028.
        </p>
      ) : (
        <p className="subtext-2 text-center text-muted">
          For computing Nifty 50 Index Returns, the Initial Fixing Date would be
          31st Aug 2023 <br /> and the Final Fixing Date would be the average
          Nifty 50 Index levels of 26th Jun 2025 and 31st Jul 2025
        </p>
      )}
      <p className="estimate-tag" onClick={props.toggleEstimatePopup}>
        Estimate Your Returns
      </p>
      <p className="subtitle">Payoff Summary</p>
      {props.mldAssetDetails.bondId === "mld3" || props.mldAssetDetails.bondId === "mld5" ? (
        ""
      ) : (
        <div className="toggle-container justify-content-center">
          <p
            className={`toggle1 ${activeComponent === "table" ? "active" : ""}`}
            onClick={() => handleToggle("table")}
          >
            View Table
          </p>
          <p
            className={`toggle2 ${activeComponent === "graph" ? "active" : ""}`}
            onClick={() => handleToggle("graph")}
          >
            View Graph
          </p>
        </div>
      )}
      <div className="img-container">{getActiveImage(activeComponent)}</div>
      {showPopUp && (
        <InfoPopup
          showPopUpText={showPopUp}
          toggleInfoPopup={handleInfoClick}
          text={popUpInfo}
        />
      )}
    </div>
  );
};

export default MldReturns;
